import angular from 'angular';
import lendingOpportunity from './lendingOpportunity';

export default angular
  .module('components.lendingOpportunity', [])
  .component('lendingOpportunity', lendingOpportunity).name;
